import { LocationTiers } from "components/flexComponents/DestinationNearest/DestinationNearestEnums";

export const getFormatTextLocationKey = (geoType: string) => {
  switch (geoType) {
    case LocationTiers.CITY:
      return "destinationNearest.city.linkTo";
    case LocationTiers.NEIGHBORHOOD:
      return "destinationNearest.neighborhood.linkTo";
    default:
      return "destinationNearest.city.linkTo";
  }
};
